import { render, staticRenderFns } from "./AmountsReporting.vue?vue&type=template&id=222b943a&scoped=true&"
import script from "./AmountsReporting.vue?vue&type=script&lang=js&"
export * from "./AmountsReporting.vue?vue&type=script&lang=js&"
import style0 from "./AmountsReporting.vue?vue&type=style&index=0&id=222b943a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b943a",
  null
  
)

export default component.exports